import React, { useEffect } from 'react'
import { connect, useSelector } from 'react-redux'

import './styles/application.sass'

import ImageVersioning from '../ImageVersioning'
import Routes from './Routes'
import { toggleAccessibilityRequired } from '../actions/appState'
import { KEY_CODES } from './utils/constants'
import { BRANDING_COLOR } from '../constants'
import { cacheMenuItemImages } from '../VNImageCache/utils'
import { getItemsImages } from '../selectors/items'
import { getSelectedMenus } from '../selectors/menus'
import { isFeatureOn } from '../VNConfigurations/Selectors'
import { VNCONFIGS_FEATURE_ENABLEMENT_KEYS } from '../VNConfigurations/Enums'

const KioskApp = ({ setAccessibilityRequired }) => {
  const menus = useSelector(getSelectedMenus)
  const itemsImages = useSelector(getItemsImages)
  const kioskOfflineEnabled = useSelector((state) => isFeatureOn(state, VNCONFIGS_FEATURE_ENABLEMENT_KEYS.KIOSK_OFFLINE))
  const disableCacheImages = useSelector((state) => isFeatureOn(state, VNCONFIGS_FEATURE_ENABLEMENT_KEYS.DISABLE_CACHE_IMAGES))

  const keyDown = (event) => {
    if (event.keyCode === KEY_CODES.JACK_IN || event.keyCode === KEY_CODES.JACK_IN_TEST) setAccessibilityRequired(true)
    if (event.keyCode === KEY_CODES.JACK_OUT || event.keyCode === KEY_CODES.JACK_OUT_TEST) setAccessibilityRequired(false)
  }

  const handleImageCaching = async () => {
    //fetch images only when kiosk offline is enabled and caching is not disabled
    if (!kioskOfflineEnabled || disableCacheImages) return

    const menuImages = [...new Set(menus.map((menu) => menu.images.detail).filter((imageUrl) => !!imageUrl))]
    cacheMenuItemImages(menuImages, itemsImages)
  }

  useEffect(() => {
    document.addEventListener('keydown', keyDown, false)
    handleImageCaching()

    return () => {
      document.removeEventListener('keydown', keyDown, false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let htmlRoot = document.getElementsByTagName('html')[0]
    htmlRoot.style.setProperty('--brand-primary', BRANDING_COLOR)
  })

  return (
    <div className="main">
      <ImageVersioning>
        <React.Fragment>
          <Routes />
        </React.Fragment>
      </ImageVersioning>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    setAccessibilityRequired: (accessibilityRequired) => dispatch(toggleAccessibilityRequired(accessibilityRequired)),
  }
}

export default connect(null, mapDispatchToProps)(KioskApp)
